<template>
  <div class="message-container d-flex justify-content-end mb-2 outbound">
    <div class="d-flex align-items-center" v-if="isSpecialMessage">
      <el-tooltip effect="light" placement="left" content="Message is preserved" v-if="isPreserved">
        <i class="fas fa-bookmark mr-1"></i>
      </el-tooltip>
      <el-tooltip effect="light" placement="left" content="Group message" v-if="isGroupMessage">
        <i class="fas fa-users mr-1"></i>
      </el-tooltip>
      <el-tooltip effect="light" placement="left" content="Drip campaign message" v-if="isCampaignMessage">
        <i class="fas fa-tint mr-1"></i>
      </el-tooltip>
    </div>
    <div class="message">
      <div class="header text-right font-weight-bold">
                <span class="outgoing-number-title"
                      v-if="outgoingNumberTitle">{{ outgoingNumberTitle | uppercase }}</span>
        <span class="outgoing-number-phone-number">{{ outgoingNumberPhoneNumber }}</span>
      </div>
      <div class="content d-flex flex-column" :style="styles">
        <div class="content-body w-100 d-flex">
          <div class="message-content w-100">{{ content }}</div>
          <message-settings :settings="settings" :message="message"></message-settings>
        </div>
        <media-list :media="media" v-if="hasMedia" :is-inbound="false"></media-list>
      </div>
      <div class="footer text-right" :class="statusClasses">
        {{ statusString | uppercase }}
      </div>
    </div>
    <div class="logo ml-1">
      <el-image
          :src="logo"
          class="avatar"
          fit="contain"
      ></el-image>
    </div>
  </div>
</template>

<script>
import ChatTextMessage from "./chat-text-message";
import MessageSettings from "../message-settings";
import MediaList from "../media-list";

export default {
  extends: ChatTextMessage,

  components: {
    MessageSettings,
    MediaList,
  },

  computed: {
    /**
     * @return {String|null}
     */
    outgoingNumberTitle() {
      return _.get(this.outgoingNumber, 'title', null);
    },

    /**
     * @return {String|null}
     */
    outgoingNumberPhoneNumber() {
      return _.get(this.outgoingNumber, 'phone_number', null);
    },

    /**
     * @return {String|null}
     */
    messageSentAt() {
      return _.get(this.message, 'sent_at', null);
    },

    /**
     * @return {String}
     */
    statusString() {
      switch (this.message.status) {
        case 1:
        case 2:
          return 'sending ...';
        case 3:
          return 'message sent: ' + (this.formatTime(this.messageSentAt) || '');
        case 4:
          return 'sending error';
        default:
          return '';
      }
    },

    /**
     * @return {Array}
     */
    statusClasses() {
      return _.get(this.message, 'status') === 4
          ? ['text-warning', 'font-weight-bold']
          : ['text-black-50'];
    },

    /**
     * @return {String}
     */
    logo() {
      return _.get(this.brand, 'logo');
    },

    /**
     * @return {Object}
     */
    styles() {
      const {
        'brand.item.text.color': color,
        'brand.item.background.color': backgroundColor
      } = _.get(this.brand, 'styles') || {};

      // remove empty values
      return _.pickBy({color, backgroundColor}, _.identity);
    },

    /**
     * @return {Boolean}
     */
    isSpecialMessage() {
      return this.isGroupMessage || this.isCampaignMessage || this.isPreserved;
    },

    /**
     * @return {Boolean}
     */
    isGroupMessage() {
      return Boolean(this.message.bulk_message_id);
    },

    /**
     * @return {Boolean}
     */
    isCampaignMessage() {
      return Boolean(this.message.campaign_id);
    },

    /**
     * @returns {boolean}
     */
    isPreserved() {
      return Boolean(_.get(this.message, 'is_preserved'));
    },

    /**
     * @return {boolean}
     */
    hasMedia() {
      return !_.isEmpty(_.get(this.message, 'media', []));
    },

    /**
     * @return {Object|null}
     */
    media() {
      return _.get(this.message, 'media', null);
    },
  },
}
</script>
